export const LABS_DATE_FILTER_API_URL='date-filter-source/NETWORKLEVER/';
export const LABS_TOP_FILTER_API_URL='standard-search/topfilter?items=';
export const LABS_CATEGORY_DETAILS_API_URL='network-measures-category-details/?request-type=LAB';
export const LABS_NET_CATEGORY_DETAILS_API_URL='network-measures-category-details/?request-type=LAB';
export const LABS_EXPORT_DETAILS_REQUEST_URL='network-measure-export-details?request-type=LAB';
export const LABS_EXPORT_DETAILS_STATUS_URL='network-measure-export-status';
export const LABS_EXPOR_LINK_DETAILS_URL='network-measure-export-download-links';